/**
 * QrImage — live client-rendered QR preview. Encodes the fhl.one/q/{code}
 * short link (or any text) with the studio design options. Rendered at 2x the
 * display size so it stays crisp on retina screens.
 */

import React, { useState, useEffect } from 'react';
import { Center, Image, Spinner } from '@chakra-ui/react';
import { qrDataUrl } from './qrStudioUtils';

export default function QrImage({ text, design, size = 140, ...boxProps }) {
  const [dataUrl, setDataUrl] = useState(null);

  const darkColor = design?.darkColor || '#1A365D';
  const lightColor = design?.lightColor || '#FFFFFF';
  const logoUrl = design?.logoUrl || '';

  useEffect(() => {
    let cancelled = false;
    if (!text) {
      setDataUrl(null);
      return undefined;
    }
    qrDataUrl(text, { darkColor, lightColor, logoUrl }, size * 2)
      .then((url) => { if (!cancelled) setDataUrl(url); })
      .catch((err) => console.warn('[QrImage] render failed:', err.message));
    return () => { cancelled = true; };
  }, [text, darkColor, lightColor, logoUrl, size]);

  if (!dataUrl) {
    return (
      <Center w={`${size}px`} h={`${size}px`} {...boxProps}>
        <Spinner size="sm" color="gray.300" />
      </Center>
    );
  }

  return (
    <Image
      src={dataUrl}
      alt="QR code"
      w={`${size}px`}
      h={`${size}px`}
      borderRadius="md"
      {...boxProps}
    />
  );
}
